import {
  GcpAccordion,
  GcpBox,
  GcpCurrencyFormat,
  GcpTypography,
} from '@back-office/ui';
import { Divider } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  () => ({
    first: {
      top: '33.3%',
    },
    second: {
      top: '66.6%',
    },
  }),
  { name: 'TransactionFee' }
);

interface TransactionFeeProps {
  calFeeAmount: string | null;
  transferAmount: string | null;
  currency: string;
  amount: string;
}

const TransactionFee: FC<TransactionFeeProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { calFeeAmount, transferAmount, currency, amount } = props;

  return (
    <GcpBox mt={1}>
      <GcpAccordion
        details={
          <GcpBox isFullWidth pl={5} position="relative" pr={5}>
            <GcpBox display="flex" justifyContent="space-between" pb={2} pt={2}>
              <GcpTypography variant="body1">
                {t('transaction_list.created_amount')}
              </GcpTypography>
              <GcpCurrencyFormat
                suffix={currency}
                value={amount}
                valueVariant="body1"
                valueWeight={500}
              />
            </GcpBox>
            <Divider absolute className={classes.first} />
            <GcpBox display="flex" justifyContent="space-between" pb={2} pt={2}>
              <GcpTypography variant="body1">
                {t('transaction_list.mdr_fee')}
              </GcpTypography>
              <GcpCurrencyFormat
                prefix={`- `}
                suffix={currency}
                value={calFeeAmount}
                valueVariant="body1"
                valueWeight={500}
              />
            </GcpBox>
            <Divider absolute className={classes.second} />
            <GcpBox display="flex" justifyContent="space-between" pb={2} pt={2}>
              <GcpTypography variant="h3">
                {t('transaction_list.transfer_amount')}
              </GcpTypography>
              <GcpBox display="flex" gap={1}>
                <GcpCurrencyFormat
                  paint="eucalyptus"
                  suffix={currency}
                  suffixVariant="body1"
                  value={transferAmount}
                  valueVariant="h3"
                />
              </GcpBox>
            </GcpBox>
          </GcpBox>
        }
        title={t('transaction_list.fee')}
      />
    </GcpBox>
  );
};

export default TransactionFee;
